import { useEffect, useState } from "react";

type DeviceType = "mobile" | "tablet" | "desktop";

export const useDimensions = () => {
  const getDeviceType = (): DeviceType => {
    const width = window.innerWidth;

    if (width < 768) return "mobile";
    if (width < 1024) return "tablet";
    return "desktop";
  };

  const [device, setDevice] = useState<DeviceType>(getDeviceType());

  useEffect(() => {
    const handleResize = () => setDevice(getDeviceType());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    device,
    isMobile: device === "mobile",
    isTablet: device === "tablet",
    isDesktop: device === "desktop",
  };
};
